import { useRootStore } from 'contexts/RootStore.context';
import { format } from 'date-fns';
import { colours } from 'styling/colours';
import { userEstimateIsNotFresh } from 'utils/utils';

const RecentUsersLastSeenCell = ({ timestamp }: { timestamp: string }) => {
  const { freshPeriodThresholdSeconds } = useRootStore()

  if (!timestamp) return <span>--</span>;

  const formattedDate = format(new Date(timestamp), 'dd MMM yyyy, HH:mm');
  const showRedHighlight = userEstimateIsNotFresh(timestamp, freshPeriodThresholdSeconds);
  return (
    <span
      className="u-no-pointer-event"
      style={showRedHighlight ? { color: `${colours.error}` } : {}}
    >
      {formattedDate}
    </span>
  );
};

export default RecentUsersLastSeenCell;
